import { getProxiedServiceUrl } from 'gw-portals-url-js';
import { JsonRPCService } from 'gw-portals-transport-js';

export default class UserProfileIDService {
    static getProfileID(additionalHeaders) {
        return JsonRPCService.send(getProxiedServiceUrl('userprofile'),
            'getProfileID', [additionalHeaders.Authorization], additionalHeaders);
    }
}
